import { Info } from 'lucide-react'
import type { PipelineTabView } from '@/components/Dashboard/pipelineTab.utils'
import { formatDashboardCurrency, formatDashboardNumber } from '@/utils/crmValuesDisplay'

type Props = {
  view: PipelineTabView
  valuesVisible?: boolean
}

export function PipelineContextBanner({ view, valuesVisible = false }: Props) {
  const { closingForecast: forecast } = view
  const hasForecast = forecast.forecastCount > 0

  return (
    <div
      className='flex gap-3 rounded-2xl border border-amber-200/80 bg-amber-50/80 px-4 py-3 dark:border-amber-900/50 dark:bg-amber-950/20'
      role='status'
    >
      <Info size={18} className='mt-0.5 shrink-0 text-amber-600 dark:text-amber-400' aria-hidden />
      <div className='min-w-0 text-sm'>
        <p className='font-medium text-text-primary'>
          {hasForecast
            ? 'Sem fechamento no período, com previsão ativa'
            : 'Pipeline ativo, sem fechamento no período'}
        </p>
        <p className='mt-1 text-text-muted'>
          {hasForecast ? (
            <>
              Previsão de {formatDashboardCurrency(forecast.forecastValue, valuesVisible)} (
              {formatDashboardNumber(forecast.proposalsSentCount, valuesVisible)} propostas enviadas)
              — nenhum ganho com data neste intervalo.
            </>
          ) : (
            <>
              {formatDashboardCurrency(view.pipelineValue, valuesVisible)} em{' '}
              {formatDashboardNumber(view.pipelineCount, valuesVisible)} negociações abertas.
              Amplie o período ou avance deals para proposta enviada.
            </>
          )}
        </p>
      </div>
    </div>
  )
}
